import { ARGOCD_ANNOTATION_APP_NAME, ARGOCD_ANNOTATION_APP_SELECTOR, ARGOCD_ANNOTATION_PROJECT_NAME } from './components/useArgoCDAppData.esm.js';

const isArgocdAvailable = (entity) => Boolean(entity?.metadata.annotations?.[ARGOCD_ANNOTATION_APP_NAME]) || Boolean(entity?.metadata.annotations?.[ARGOCD_ANNOTATION_APP_SELECTOR]) || Boolean(entity?.metadata.annotations?.[ARGOCD_ANNOTATION_PROJECT_NAME]);

export { isArgocdAvailable };
//# sourceMappingURL=conditions.esm.js.map
